import { stopPropagationForHotKeysFromInput } from '@modules/taxonomy/helpers/stopEventPropagationForHotkeysFromInput';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { Stack, TextField, TextFieldProps, Typography } from '@mui/material';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { toTitleCase } from 'v2/utils/strings';

interface ReasonDescriptionInputProps {
  description: string | undefined;
  onDescriptionChange: (description: string) => void;
  showAdditionalDetails?: boolean;
  textFieldProps?: TextFieldProps;
}

export const ReasonDescriptionInput = ({
  description,
  onDescriptionChange,
  showAdditionalDetails = true,
  textFieldProps = {},
}: ReasonDescriptionInputProps) => {
  const selectedReasonDefinition = useTaxonomyStore(
    ({ createReasonV3State: { misc } }) => misc?.selectedReasonDefinition,
  );

  const selectedDefinitionName = selectedReasonDefinition?.name;

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1}>
        {showAdditionalDetails && <Typography variant="h4">📝</Typography>}
        <Stack>
          <Typography variant="subtitle2">
            Describe the customer feedback where{' '}
            {selectedDefinitionName
              ? `"${toTitleCase(selectedDefinitionName)}"`
              : 'this'}{' '}
            Reason should be present.
          </Typography>
          {showAdditionalDetails && (
            <Typography variant="caption" color="text.disabled">
              We will use this as a prompt to find matching Reason Definitions
              for you to review.
            </Typography>
          )}
        </Stack>
      </Stack>
      <TextField
        fullWidth
        multiline
        placeholder="Enter your prompt to create a new Reason"
        rows={4}
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        onKeyDown={stopPropagationForHotKeysFromInput}
        {...textFieldProps}
      />
    </Stack>
  );
};
